@file:OptIn(InternalResourceApi::class)

package dentalcrm.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/dentalcrm.composeapp.generated.resources/"

@delegate:ResourceContentHash(1_872_538_998)
internal val Res.string.access_to_system: StringResource by lazy {
      StringResource("string:access_to_system", "access_to_system", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 76),
      ))
    }

@delegate:ResourceContentHash(-678_129_173)
internal val Res.string.add: StringResource by lazy {
      StringResource("string:add", "add", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1006, 35),
      ))
    }

@delegate:ResourceContentHash(1_812_429_620)
internal val Res.string.add_appointment: StringResource by lazy {
      StringResource("string:add_appointment", "add_appointment", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 87, 63),
      ))
    }

@delegate:ResourceContentHash(1_054_709_044)
internal val Res.string.add_employee: StringResource by lazy {
      StringResource("string:add_employee", "add_employee", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 151, 72),
      ))
    }

@delegate:ResourceContentHash(205_948_129)
internal val Res.string.add_option: StringResource by lazy {
      StringResource("string:add_option", "add_option", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 224, 54),
      ))
    }

@delegate:ResourceContentHash(1_798_490_540)
internal val Res.string.add_patient: StringResource by lazy {
      StringResource("string:add_patient", "add_patient", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 357, 63),
      ))
    }

@delegate:ResourceContentHash(1_240_904_872)
internal val Res.string.add_patient_title: StringResource by lazy {
      StringResource("string:add_patient_title", "add_patient_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 279, 77),
      ))
    }

@delegate:ResourceContentHash(1_449_808_040)
internal val Res.string.add_position_title: StringResource by lazy {
      StringResource("string:add_position_title", "add_position_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 421, 74),
      ))
    }

@delegate:ResourceContentHash(-2_015_482_416)
internal val Res.string.add_protocol: StringResource by lazy {
      StringResource("string:add_protocol", "add_protocol", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 496, 64),
      ))
    }

@delegate:ResourceContentHash(1_325_244_850)
internal val Res.string.add_question: StringResource by lazy {
      StringResource("string:add_question", "add_question", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 561, 60),
      ))
    }

@delegate:ResourceContentHash(945_285_527)
internal val Res.string.add_service_category_title: StringResource by lazy {
      StringResource("string:add_service_category_title", "add_service_category_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 622, 98),
      ))
    }

@delegate:ResourceContentHash(-1_169_089_182)
internal val Res.string.add_service_label: StringResource by lazy {
      StringResource("string:add_service_label", "add_service_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 721, 65),
      ))
    }

@delegate:ResourceContentHash(-1_403_506_112)
internal val Res.string.add_title_optional: StringResource by lazy {
      StringResource("string:add_title_optional", "add_title_optional", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 787, 114),
      ))
    }

@delegate:ResourceContentHash(-1_065_325_594)
internal val Res.string.add_treatment_title: StringResource by lazy {
      StringResource("string:add_treatment_title", "add_treatment_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 902, 71),
      ))
    }

@delegate:ResourceContentHash(-998_184_101)
internal val Res.string.address: StringResource by lazy {
      StringResource("string:address", "address", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 974, 31),
      ))
    }

@delegate:ResourceContentHash(891_713_782)
internal val Res.string.answer_to_whats_app: StringResource by lazy {
      StringResource("string:answer_to_whats_app", "answer_to_whats_app", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1042, 67),
      ))
    }

@delegate:ResourceContentHash(-1_120_696_944)
internal val Res.string.appointment_date: StringResource by lazy {
      StringResource("string:appointment_date", "appointment_date", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1110, 52),
      ))
    }

@delegate:ResourceContentHash(1_969_003_481)
internal val Res.string.appointment_doctor_label: StringResource by lazy {
      StringResource("string:appointment_doctor_label", "appointment_doctor_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1163, 56),
      ))
    }

@delegate:ResourceContentHash(-684_870_443)
internal val Res.string.appointment_time: StringResource by lazy {
      StringResource("string:appointment_time", "appointment_time", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1220, 44),
      ))
    }

@delegate:ResourceContentHash(-1_660_551_746)
internal val Res.string.appointments: StringResource by lazy {
      StringResource("string:appointments", "appointments", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1361, 36),
      ))
    }

@delegate:ResourceContentHash(-1_485_955_663)
internal val Res.string.appointments_formatter: StringResource by lazy {
      StringResource("string:appointments_formatter", "appointments_formatter", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1265, 54),
      ))
    }

@delegate:ResourceContentHash(1_864_780_423)
internal val Res.string.appointments_tab: StringResource by lazy {
      StringResource("string:appointments_tab", "appointments_tab", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1320, 40),
      ))
    }

@delegate:ResourceContentHash(1_505_328)
internal val Res.string.at: StringResource by lazy {
      StringResource("string:at", "at", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1398, 14),
      ))
    }

@delegate:ResourceContentHash(38_433_629)
internal val Res.string.birth_date_required: StringResource by lazy {
      StringResource("string:birth_date_required", "birth_date_required", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1413, 91),
      ))
    }

@delegate:ResourceContentHash(-1_064_028_311)
internal val Res.string.birthday: StringResource by lazy {
      StringResource("string:birthday", "birthday", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1505, 52),
      ))
    }

@delegate:ResourceContentHash(-1_626_474_403)
internal val Res.string.call_by_phone: StringResource by lazy {
      StringResource("string:call_by_phone", "call_by_phone", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1558, 69),
      ))
    }

@delegate:ResourceContentHash(1_479_661_585)
internal val Res.string.cancel: StringResource by lazy {
      StringResource("string:cancel", "cancel", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1628, 38),
      ))
    }

@delegate:ResourceContentHash(581_960_302)
internal val Res.string.change_password: StringResource by lazy {
      StringResource("string:change_password", "change_password", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1667, 55),
      ))
    }

@delegate:ResourceContentHash(-1_273_325_681)
internal val Res.string.choose_date_of_appointment: StringResource by lazy {
      StringResource("string:choose_date_of_appointment", "choose_date_of_appointment", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1723, 86),
      ))
    }

@delegate:ResourceContentHash(-121_437_314)
internal val Res.string.choose_gender: StringResource by lazy {
      StringResource("string:choose_gender", "choose_gender", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1810, 53),
      ))
    }

@delegate:ResourceContentHash(2_046_083_382)
internal val Res.string.choose_reply_action: StringResource by lazy {
      StringResource("string:choose_reply_action", "choose_reply_action", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1864, 71),
      ))
    }

@delegate:ResourceContentHash(1_273_223_926)
internal val Res.string.city: StringResource by lazy {
      StringResource("string:city", "city", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1936, 28),
      ))
    }

@delegate:ResourceContentHash(-1_946_496_828)
internal val Res.string.code: StringResource by lazy {
      StringResource("string:code", "code", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1965, 20),
      ))
    }

@delegate:ResourceContentHash(-1_783_879_306)
internal val Res.string.color_label: StringResource by lazy {
      StringResource("string:color_label", "color_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1986, 31),
      ))
    }

@delegate:ResourceContentHash(-1_806_081_736)
internal val Res.string.comment_append: StringResource by lazy {
      StringResource("string:comment_append", "comment_append", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2018, 54),
      ))
    }

@delegate:ResourceContentHash(1_753_546_379)
internal val Res.string.confirm: StringResource by lazy {
      StringResource("string:confirm", "confirm", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2073, 47),
      ))
    }

@delegate:ResourceContentHash(1_233_213_715)
internal val Res.string.connect: StringResource by lazy {
      StringResource("string:connect", "connect", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2121, 39),
      ))
    }

@delegate:ResourceContentHash(1_878_625_672)
internal val Res.string.contact_info: StringResource by lazy {
      StringResource("string:contact_info", "contact_info", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2161, 76),
      ))
    }

@delegate:ResourceContentHash(-1_888_590_004)
internal val Res.string.custom_option_placeholder: StringResource by lazy {
      StringResource("string:custom_option_placeholder", "custom_option_placeholder", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2238, 65),
      ))
    }

@delegate:ResourceContentHash(1_677_940_184)
internal val Res.string.cyclone: StringResource by lazy {
      StringResource("string:cyclone", "cyclone", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2304, 27),
      ))
    }

@delegate:ResourceContentHash(1_932_771_493)
internal val Res.string.delete: StringResource by lazy {
      StringResource("string:delete", "delete", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2332, 34),
      ))
    }

@delegate:ResourceContentHash(763_440_363)
internal val Res.string.description: StringResource by lazy {
      StringResource("string:description", "description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2367, 43),
      ))
    }

@delegate:ResourceContentHash(-1_268_465_727)
internal val Res.string.details: StringResource by lazy {
      StringResource("string:details", "details", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2411, 31),
      ))
    }

@delegate:ResourceContentHash(-1_116_536_947)
internal val Res.string.diagnosis: StringResource by lazy {
      StringResource("string:diagnosis", "diagnosis", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2659, 41),
      ))
    }

@delegate:ResourceContentHash(-1_189_428_445)
internal val Res.string.diagnosis_add_title: StringResource by lazy {
      StringResource("string:diagnosis_add_title", "diagnosis_add_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2443, 71),
      ))
    }

@delegate:ResourceContentHash(-1_596_490_722)
internal val Res.string.diagnosis_delete_title: StringResource by lazy {
      StringResource("string:diagnosis_delete_title", "diagnosis_delete_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2515, 70),
      ))
    }

@delegate:ResourceContentHash(-2_132_597_811)
internal val Res.string.diagnosis_edit_title: StringResource by lazy {
      StringResource("string:diagnosis_edit_title", "diagnosis_edit_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2586, 72),
      ))
    }

@delegate:ResourceContentHash(-366_820_129)
internal val Res.string.dialog_log_out_message: StringResource by lazy {
      StringResource("string:dialog_log_out_message", "dialog_log_out_message", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2701, 142),
      ))
    }

@delegate:ResourceContentHash(-1_904_292_529)
internal val Res.string.dialog_log_out_title: StringResource by lazy {
      StringResource("string:dialog_log_out_title", "dialog_log_out_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2844, 96),
      ))
    }

@delegate:ResourceContentHash(2_130_622_515)
internal val Res.string.discount_label: StringResource by lazy {
      StringResource("string:discount_label", "discount_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2941, 42),
      ))
    }

@delegate:ResourceContentHash(-505_694_377)
internal val Res.string.doctor_formatter: StringResource by lazy {
      StringResource("string:doctor_formatter", "doctor_formatter", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2984, 36),
      ))
    }

@delegate:ResourceContentHash(-2_004_907_540)
internal val Res.string.doctors: StringResource by lazy {
      StringResource("string:doctors", "doctors", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3021, 43),
      ))
    }

@delegate:ResourceContentHash(1_953_301_684)
internal val Res.string.done: StringResource by lazy {
      StringResource("string:done", "done", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3065, 28),
      ))
    }

@delegate:ResourceContentHash(1_966_107_541)
internal val Res.string.edit: StringResource by lazy {
      StringResource("string:edit", "edit", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3589, 36),
      ))
    }

@delegate:ResourceContentHash(1_927_322_906)
internal val Res.string.edit_appointment_title: StringResource by lazy {
      StringResource("string:edit_appointment_title", "edit_appointment_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3094, 86),
      ))
    }

@delegate:ResourceContentHash(198_421_027)
internal val Res.string.edit_button: StringResource by lazy {
      StringResource("string:edit_button", "edit_button", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3181, 55),
      ))
    }

@delegate:ResourceContentHash(117_888_173)
internal val Res.string.edit_employee: StringResource by lazy {
      StringResource("string:edit_employee", "edit_employee", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3237, 85),
      ))
    }

@delegate:ResourceContentHash(1_289_664_575)
internal val Res.string.edit_position_title: StringResource by lazy {
      StringResource("string:edit_position_title", "edit_position_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3323, 87),
      ))
    }

@delegate:ResourceContentHash(1_336_315_514)
internal val Res.string.edit_protocol: StringResource by lazy {
      StringResource("string:edit_protocol", "edit_protocol", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3411, 65),
      ))
    }

@delegate:ResourceContentHash(-871_543_654)
internal val Res.string.edit_service_category_title: StringResource by lazy {
      StringResource("string:edit_service_category_title", "edit_service_category_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3477, 111),
      ))
    }

@delegate:ResourceContentHash(-957_383_799)
internal val Res.string.email: StringResource by lazy {
      StringResource("string:email", "email", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3709, 21),
      ))
    }

@delegate:ResourceContentHash(-2_046_531_128)
internal val Res.string.email_hint: StringResource by lazy {
      StringResource("string:email_hint", "email_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3626, 54),
      ))
    }

@delegate:ResourceContentHash(-1_713_180_008)
internal val Res.string.email_label: StringResource by lazy {
      StringResource("string:email_label", "email_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3681, 27),
      ))
    }

@delegate:ResourceContentHash(-2_004_907_540)
internal val Res.string.employees: StringResource by lazy {
      StringResource("string:employees", "employees", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3908, 45),
      ))
    }

@delegate:ResourceContentHash(305_615_327)
internal val Res.string.employees_load_error: StringResource by lazy {
      StringResource("string:employees_load_error", "employees_load_error", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3731, 176),
      ))
    }

@delegate:ResourceContentHash(-684_660_938)
internal val Res.string.empty_diagnosis: StringResource by lazy {
      StringResource("string:empty_diagnosis", "empty_diagnosis", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3954, 79),
      ))
    }

@delegate:ResourceContentHash(-1_010_429_083)
internal val Res.string.empty_name_err: StringResource by lazy {
      StringResource("string:empty_name_err", "empty_name_err", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4034, 58),
      ))
    }

@delegate:ResourceContentHash(-1_985_086_239)
internal val Res.string.empty_phone_err: StringResource by lazy {
      StringResource("string:empty_phone_err", "empty_phone_err", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4093, 83),
      ))
    }

@delegate:ResourceContentHash(-694_205_205)
internal val Res.string.empty_positions: StringResource by lazy {
      StringResource("string:empty_positions", "empty_positions", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4177, 91),
      ))
    }

@delegate:ResourceContentHash(1_843_602_835)
internal val Res.string.empty_protocols: StringResource by lazy {
      StringResource("string:empty_protocols", "empty_protocols", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4269, 99),
      ))
    }

@delegate:ResourceContentHash(697_025_092)
internal val Res.string.empty_quick_replies: StringResource by lazy {
      StringResource("string:empty_quick_replies", "empty_quick_replies", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4369, 103),
      ))
    }

@delegate:ResourceContentHash(1_555_493_923)
internal val Res.string.empty_service_categories: StringResource by lazy {
      StringResource("string:empty_service_categories", "empty_service_categories", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4473, 108),
      ))
    }

@delegate:ResourceContentHash(-2_126_860_817)
internal val Res.string.empty_services: StringResource by lazy {
      StringResource("string:empty_services", "empty_services", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4582, 66),
      ))
    }

@delegate:ResourceContentHash(531_940_209)
internal val Res.string.empty_surname_err: StringResource by lazy {
      StringResource("string:empty_surname_err", "empty_surname_err", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4649, 73),
      ))
    }

@delegate:ResourceContentHash(1_713_486_030)
internal val Res.string.error_login: StringResource by lazy {
      StringResource("string:error_login", "error_login", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4723, 83),
      ))
    }

@delegate:ResourceContentHash(1_571_921_818)
internal val Res.string.error_message: StringResource by lazy {
      StringResource("string:error_message", "error_message", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4807, 101),
      ))
    }

@delegate:ResourceContentHash(1_309_815_940)
internal val Res.string.error_no_records: StringResource by lazy {
      StringResource("string:error_no_records", "error_no_records", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4909, 100),
      ))
    }

@delegate:ResourceContentHash(-2_051_582_223)
internal val Res.string.fill_out_card: StringResource by lazy {
      StringResource("string:fill_out_card", "fill_out_card", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5010, 61),
      ))
    }

@delegate:ResourceContentHash(-527_062_996)
internal val Res.string.finance: StringResource by lazy {
      StringResource("string:finance", "finance", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5072, 35),
      ))
    }

@delegate:ResourceContentHash(1_147_159_584)
internal val Res.string.find_patient: StringResource by lazy {
      StringResource("string:find_patient", "find_patient", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5108, 56),
      ))
    }

@delegate:ResourceContentHash(430_317_358)
internal val Res.string.gender: StringResource by lazy {
      StringResource("string:gender", "gender", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5307, 22),
      ))
    }

@delegate:ResourceContentHash(-371_496_449)
internal val Res.string.gender_female: StringResource by lazy {
      StringResource("string:gender_female", "gender_female", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5165, 41),
      ))
    }

@delegate:ResourceContentHash(-1_780_786_022)
internal val Res.string.gender_male: StringResource by lazy {
      StringResource("string:gender_male", "gender_male", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5207, 39),
      ))
    }

@delegate:ResourceContentHash(1_207_213_250)
internal val Res.string.gender_required: StringResource by lazy {
      StringResource("string:gender_required", "gender_required", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5247, 59),
      ))
    }

@delegate:ResourceContentHash(-1_436_904_523)
internal val Res.string.hide: StringResource by lazy {
      StringResource("string:hide", "hide", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5330, 28),
      ))
    }

@delegate:ResourceContentHash(2_119_132_675)
internal val Res.string.idn: StringResource by lazy {
      StringResource("string:idn", "idn", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5422, 19),
      ))
    }

@delegate:ResourceContentHash(1_716_059_172)
internal val Res.string.idn_number: StringResource by lazy {
      StringResource("string:idn_number", "idn_number", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5359, 62),
      ))
    }

@delegate:ResourceContentHash(1_337_886_790)
internal val Res.string.initial_inspection_header: StringResource by lazy {
      StringResource("string:initial_inspection_header", "initial_inspection_header", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5442, 77),
      ))
    }

@delegate:ResourceContentHash(970_873_454)
internal val Res.string.initial_inspection_title: StringResource by lazy {
      StringResource("string:initial_inspection_title", "initial_inspection_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5520, 72),
      ))
    }

@delegate:ResourceContentHash(-1_279_573_080)
internal val Res.string.inspection_date_label: StringResource by lazy {
      StringResource("string:inspection_date_label", "inspection_date_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5593, 61),
      ))
    }

@delegate:ResourceContentHash(-1_183_156_848)
internal val Res.string.list_empty: StringResource by lazy {
      StringResource("string:list_empty", "list_empty", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5655, 46),
      ))
    }

@delegate:ResourceContentHash(224_486_876)
internal val Res.string.log_out: StringResource by lazy {
      StringResource("string:log_out", "log_out", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5750, 31),
      ))
    }

@delegate:ResourceContentHash(1_232_309_237)
internal val Res.string.log_out_confirm: StringResource by lazy {
      StringResource("string:log_out_confirm", "log_out_confirm", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5702, 47),
      ))
    }

@delegate:ResourceContentHash(-744_949_847)
internal val Res.string.login: StringResource by lazy {
      StringResource("string:login", "login", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5898, 29),
      ))
    }

@delegate:ResourceContentHash(-1_376_970_977)
internal val Res.string.login_sub_title: StringResource by lazy {
      StringResource("string:login_sub_title", "login_sub_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5782, 87),
      ))
    }

@delegate:ResourceContentHash(-1_956_979_050)
internal val Res.string.login_title: StringResource by lazy {
      StringResource("string:login_title", "login_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5870, 27),
      ))
    }

@delegate:ResourceContentHash(1_733_408_487)
internal val Res.string.main_info: StringResource by lazy {
      StringResource("string:main_info", "main_info", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5928, 69),
      ))
    }

@delegate:ResourceContentHash(26_756_073)
internal val Res.string.menu: StringResource by lazy {
      StringResource("string:menu", "menu", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5998, 24),
      ))
    }

@delegate:ResourceContentHash(-1_427_945_661)
internal val Res.string.month_eight: StringResource by lazy {
      StringResource("string:month_eight", "month_eight", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6057, 35),
      ))
    }

@delegate:ResourceContentHash(1_031_440_223)
internal val Res.string.month_eight_short: StringResource by lazy {
      StringResource("string:month_eight_short", "month_eight_short", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6023, 33),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("access_to_system", Res.string.access_to_system)
  map.put("add", Res.string.add)
  map.put("add_appointment", Res.string.add_appointment)
  map.put("add_employee", Res.string.add_employee)
  map.put("add_option", Res.string.add_option)
  map.put("add_patient", Res.string.add_patient)
  map.put("add_patient_title", Res.string.add_patient_title)
  map.put("add_position_title", Res.string.add_position_title)
  map.put("add_protocol", Res.string.add_protocol)
  map.put("add_question", Res.string.add_question)
  map.put("add_service_category_title", Res.string.add_service_category_title)
  map.put("add_service_label", Res.string.add_service_label)
  map.put("add_title_optional", Res.string.add_title_optional)
  map.put("add_treatment_title", Res.string.add_treatment_title)
  map.put("address", Res.string.address)
  map.put("answer_to_whats_app", Res.string.answer_to_whats_app)
  map.put("appointment_date", Res.string.appointment_date)
  map.put("appointment_doctor_label", Res.string.appointment_doctor_label)
  map.put("appointment_time", Res.string.appointment_time)
  map.put("appointments", Res.string.appointments)
  map.put("appointments_formatter", Res.string.appointments_formatter)
  map.put("appointments_tab", Res.string.appointments_tab)
  map.put("at", Res.string.at)
  map.put("birth_date_required", Res.string.birth_date_required)
  map.put("birthday", Res.string.birthday)
  map.put("call_by_phone", Res.string.call_by_phone)
  map.put("cancel", Res.string.cancel)
  map.put("change_password", Res.string.change_password)
  map.put("choose_date_of_appointment", Res.string.choose_date_of_appointment)
  map.put("choose_gender", Res.string.choose_gender)
  map.put("choose_reply_action", Res.string.choose_reply_action)
  map.put("city", Res.string.city)
  map.put("code", Res.string.code)
  map.put("color_label", Res.string.color_label)
  map.put("comment_append", Res.string.comment_append)
  map.put("confirm", Res.string.confirm)
  map.put("connect", Res.string.connect)
  map.put("contact_info", Res.string.contact_info)
  map.put("custom_option_placeholder", Res.string.custom_option_placeholder)
  map.put("cyclone", Res.string.cyclone)
  map.put("delete", Res.string.delete)
  map.put("description", Res.string.description)
  map.put("details", Res.string.details)
  map.put("diagnosis", Res.string.diagnosis)
  map.put("diagnosis_add_title", Res.string.diagnosis_add_title)
  map.put("diagnosis_delete_title", Res.string.diagnosis_delete_title)
  map.put("diagnosis_edit_title", Res.string.diagnosis_edit_title)
  map.put("dialog_log_out_message", Res.string.dialog_log_out_message)
  map.put("dialog_log_out_title", Res.string.dialog_log_out_title)
  map.put("discount_label", Res.string.discount_label)
  map.put("doctor_formatter", Res.string.doctor_formatter)
  map.put("doctors", Res.string.doctors)
  map.put("done", Res.string.done)
  map.put("edit", Res.string.edit)
  map.put("edit_appointment_title", Res.string.edit_appointment_title)
  map.put("edit_button", Res.string.edit_button)
  map.put("edit_employee", Res.string.edit_employee)
  map.put("edit_position_title", Res.string.edit_position_title)
  map.put("edit_protocol", Res.string.edit_protocol)
  map.put("edit_service_category_title", Res.string.edit_service_category_title)
  map.put("email", Res.string.email)
  map.put("email_hint", Res.string.email_hint)
  map.put("email_label", Res.string.email_label)
  map.put("employees", Res.string.employees)
  map.put("employees_load_error", Res.string.employees_load_error)
  map.put("empty_diagnosis", Res.string.empty_diagnosis)
  map.put("empty_name_err", Res.string.empty_name_err)
  map.put("empty_phone_err", Res.string.empty_phone_err)
  map.put("empty_positions", Res.string.empty_positions)
  map.put("empty_protocols", Res.string.empty_protocols)
  map.put("empty_quick_replies", Res.string.empty_quick_replies)
  map.put("empty_service_categories", Res.string.empty_service_categories)
  map.put("empty_services", Res.string.empty_services)
  map.put("empty_surname_err", Res.string.empty_surname_err)
  map.put("error_login", Res.string.error_login)
  map.put("error_message", Res.string.error_message)
  map.put("error_no_records", Res.string.error_no_records)
  map.put("fill_out_card", Res.string.fill_out_card)
  map.put("finance", Res.string.finance)
  map.put("find_patient", Res.string.find_patient)
  map.put("gender", Res.string.gender)
  map.put("gender_female", Res.string.gender_female)
  map.put("gender_male", Res.string.gender_male)
  map.put("gender_required", Res.string.gender_required)
  map.put("hide", Res.string.hide)
  map.put("idn", Res.string.idn)
  map.put("idn_number", Res.string.idn_number)
  map.put("initial_inspection_header", Res.string.initial_inspection_header)
  map.put("initial_inspection_title", Res.string.initial_inspection_title)
  map.put("inspection_date_label", Res.string.inspection_date_label)
  map.put("list_empty", Res.string.list_empty)
  map.put("log_out", Res.string.log_out)
  map.put("log_out_confirm", Res.string.log_out_confirm)
  map.put("login", Res.string.login)
  map.put("login_sub_title", Res.string.login_sub_title)
  map.put("login_title", Res.string.login_title)
  map.put("main_info", Res.string.main_info)
  map.put("menu", Res.string.menu)
  map.put("month_eight", Res.string.month_eight)
  map.put("month_eight_short", Res.string.month_eight_short)
}
